export const CONTACT_LIST_LIMIT = 20;
export const QUERY_PARAMS_OPTIONS = {
  stripUnknownKeys: false,
  queryStringOptions: {
    skipNull: true,
    skipEmptyString: true,
  },
};
